(() => {
  const menu = document.querySelector('[data-chewsy-menu]');
  const navigation = document.getElementById('mobile-nav');
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    if (open) {
      const header = document.querySelector('.site-header');
      navigation.style.top = Math.max(0, header ? header.getBoundingClientRect().bottom : 0) + 'px';
    }
    navigation.hidden = !open;
  });
  navigation?.addEventListener('click', event => {
    if (event.target.closest('a')) { menu.setAttribute('aria-expanded', 'false'); navigation.hidden = true; }
  });
  document.querySelectorAll('[data-family-selector]').forEach(select => {
    select.addEventListener('change', () => {
      const destination = new URL(select.value, location.origin);
      if (destination.origin === location.origin && destination.pathname.includes('/products/')) {
        location.assign(destination.href);
      }
    });
  });
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const show = index => {
      thumbnails.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
      const image = thumbnails[index].querySelector('img').cloneNode();
      image.loading = 'eager';
      main.replaceChildren(image);
    };
    thumbnails.forEach((button, index) => {
      button.addEventListener('click', () => show(index));
      button.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbnails.length;
        else if (event.key === 'ArrowLeft') next = (index + thumbnails.length - 1) % thumbnails.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = thumbnails.length - 1;
        else return;
        event.preventDefault();
        show(next);
        thumbnails[next].focus();
      });
    });
  });
  const contextParameters = new URLSearchParams(location.search);
  const contactContext = ['dog','event'].map(key => contextParameters.get(key)).filter(Boolean).join('\n\n');
  if (contactContext && location.pathname.endsWith('/pages/contact')) {
    const body = document.querySelector('textarea[name="contact[body]"]');
    if (body && !body.value) body.value = contactContext.slice(0, 1500);
  }
  const shop = document.querySelector('[data-chewsy-shop]');
  if (!shop) return;
  const start = () => {
    const metadata = window.ChewsyCatalogMetadata;
    if (!metadata) return;
    const grid = shop.querySelector('[data-product-grid]');
    const cards = [...grid.querySelectorAll('[data-product-card]')];
    const nativeOrder = JSON.parse(shop.querySelector('[data-original-catalog-order]').textContent);
    const nativeIndex = new Map(nativeOrder.map((id, index) => [String(id), index]));
    const byId = new Map(cards.map(card => [card.dataset.productId, card]));
    const grouped = new Set();
    const records = [];
    const categoryByProductType = new Map([
      ['chews', ['chew', 'chews', 'natural chews', 'dog chews']],
      ['treats', ['treat', 'treats', 'dog treats', 'food topper', 'food toppers']],
      ['bundles', ['bundle', 'bundles', 'variety pack', 'variety packs', 'sampler', 'samplers']],
      ['box', ['box', 'chewsy box', 'monthly box', 'subscription box']],
      ['extras', ['extra', 'extras', 'accessory', 'accessories', 'toy', 'toys']]
    ].flatMap(([category, types]) => types.map(type => [type, category])));
    const categoryFor = card => metadata.products[card.dataset.productId]?.category
      ?? categoryByProductType.get((card.querySelector('[data-card-category]')?.textContent ?? '').trim().toLowerCase().replace(/\s+/g, ' '))
      ?? 'extras';
    const makeRecord = (card, members = [card], family = null) => {
      const available = members.some(member => member.dataset.available === 'true');
      const buyable = members.filter(member => member.dataset.available === 'true');
      const priced = buyable.length ? buyable : members;
      const cheapest = priced.reduce((a, b) => Number(a.dataset.price) <= Number(b.dataset.price) ? a : b);
      const record = {
        card, members, family, available,
        title: family?.title ?? card.dataset.title,
        price: Number(cheapest.dataset.price),
        index: Math.min(...members.map(member => nativeIndex.get(member.dataset.productId) ?? Number.MAX_SAFE_INTEGER)),
        categories: new Set(members.map(categoryFor)),
        text: members.map(member => `${member.dataset.title} ${member.dataset.description}`).join(' ').toLowerCase()
      };
      if (family?.name === 'Pack size') record.categories.add('bundles');
      if (family) {
        const title = card.querySelector('[data-card-title]');
        title.textContent = family.title;
        const cardOptions = card.querySelector('[data-card-options]');
        if (family.name === 'Flavor' && cardOptions.dataset.flavorText) cardOptions.textContent = cardOptions.dataset.flavorText;
        cardOptions.hidden = false;
        card.querySelector('[data-from-label]').hidden = !members.some(member => Number(member.dataset.price) !== record.price);
        card.querySelector('[data-card-price]').textContent = cheapest.querySelector('[data-card-price]').textContent;
      }
      records.push(record);
    };
    for (const family of metadata.families) {
      const members = family.choices.map(choice => byId.get(choice.id));
      if (members.some((card, index) => !card || card.dataset.variantCount !== '1' || card.dataset.variantId !== family.choices[index].variant)) continue;
      const representative = members.find(card => card.dataset.available === 'true') ?? members[0];
      members.forEach(card => {
        grouped.add(card);
        if (card !== representative) card.remove();
      });
      makeRecord(representative, members, family);
    }
    for (const card of cards) if (!grouped.has(card)) makeRecord(card);
    const search = shop.querySelector('[data-shop-search]');
    const category = shop.querySelector('[data-shop-category]');
    const sort = shop.querySelector('[data-shop-sort]');
    const stock = shop.querySelector('[data-shop-stock]');
    const finder = shop.querySelector('[data-dog-finder]');
    let avoid = [];
    let fit = { size: '', style: '', puppy: false };
    const matchesDog = record => (!avoid.length && !fit.size && !fit.style && !fit.puppy) || record.members.some(member => {
      const product = metadata.products[member.dataset.productId];
      if (!product) return false;
      const values = value => Array.isArray(value) ? value : value ? [value] : [];
      const known = [...values(product.proteins), ...values(product.ingredients)].join(' ').toLowerCase();
      const safe = !avoid.some(ingredient => known.includes(ingredient) || member.dataset.title.toLowerCase().includes(ingredient));
      return safe
        && (!fit.size || values(product.sizes).includes(fit.size))
        && (!fit.style || values(product.chew).includes(fit.style))
        && (!fit.puppy || product.puppy === true);
    });
    const collator = new Intl.Collator(document.documentElement.lang, { numeric: true, sensitivity: 'base' });
    const render = () => {
      const query = search.value.trim().toLowerCase();
      const ordered = [...records].sort((a, b) => {
        if (sort.value === 'featured') return a.index - b.index;
        const price = sort.value === 'price-low' ? a.price - b.price : sort.value === 'price-high' ? b.price - a.price : 0;
        return price || collator.compare(a.title, b.title);
      });
      let count = 0;
      for (const record of ordered) {
        const visible = (!query || record.text.includes(query) || record.title.toLowerCase().includes(query))
          && (category.value === 'all' || record.categories.has(category.value))
          && (!stock.checked || record.available) && matchesDog(record);
        record.card.hidden = !visible;
        if (visible) count++;
        grid.append(record.card);
      }
      shop.querySelector('[data-shop-results]').textContent = `${count} ${shop.dataset.resultsLabel}`;
      shop.querySelector('[data-shop-empty]').hidden = count !== 0;
    };
    [search, category, sort, stock].forEach(control => control.addEventListener('input', render));
    finder?.addEventListener('submit', event => {
      event.preventDefault();
      const answers = new FormData(finder);
      avoid = answers.getAll('avoid');
      fit = { size: answers.get('size') || '', style: answers.get('style') || '', puppy: answers.get('puppy') === 'yes' };
      render();
      shop.querySelector('[data-dog-status]').textContent = finder.dataset.status || '';
      const labels = [...finder.querySelectorAll('select')].flatMap(select => select.value ? [`${select.closest('label').firstChild.textContent.trim()}: ${select.selectedOptions[0].textContent}`] : []);
      if (fit.puppy) labels.push('Puppy');
      const ingredients = [...finder.querySelectorAll('input[name="avoid"]:checked')].map(input => input.closest('label').textContent.trim());
      if (ingredients.length) labels.push(ingredients.join(', '));
      const summary = labels.join(' · ');
      shop.querySelector('[data-dog-summary]').textContent = summary;
      const contact = finder.querySelector('[data-dog-contact]');
      contact.href = '/pages/contact?dog=' + encodeURIComponent(summary);
      contact.hidden = !summary;
      grid.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    finder?.addEventListener('reset', () => {
      avoid = [];
      fit = { size: '', style: '', puppy: false };
      queueMicrotask(render);
      shop.querySelector('[data-dog-status]').textContent = '';
      shop.querySelector('[data-dog-summary]').textContent = '';
      finder.querySelector('[data-dog-contact]').hidden = true;
    });
    render();
  };
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
